export default "__VITE_ASSET__B9V$ggQp__"